import { render } from "./Attendtotal.vue?vue&type=template&id=6050d742&scoped=true"
import script from "./Attendtotal.vue?vue&type=script&lang=js"
export * from "./Attendtotal.vue?vue&type=script&lang=js"

import "./Attendtotal.vue?vue&type=style&index=0&id=6050d742&scoped=true&lang=css"

import exportComponent from "/var/www/html/youthmanna/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6050d742"]])

export default __exports__